import { evidenceTypes, evidenceLabelMap, type EvidenceKey } from '@/mocks/cases';

const iconMap: Record<EvidenceKey, string> = {
  audio: 'ri-mic-line',
  video: 'ri-film-line',
  contract: 'ri-file-paper-2-line',
  transfer: 'ri-exchange-dollar-line',
};

export function EvidenceTag({ type }: { type: EvidenceKey }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-md bg-accent-100 px-2 py-1 text-xs text-accent-900">
      <i className={iconMap[type]}></i>
      {evidenceLabelMap[type]}
    </span>
  );
}

export function EvidenceLegend() {
  return (
    <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {evidenceTypes.map((type) => (
        <li key={type.key} className="rounded-lg border border-background-200 bg-background-50 p-4">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
            <i className={`${type.icon} text-lg`}></i>
          </span>
          <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{type.name}</h3>
          <p className="mt-1 text-sm leading-relaxed text-foreground-600">{type.desc}</p>
        </li>
      ))}
    </ul>
  );
}